import type { TState } from './state';

export enum ActionTypes {
    SET_STATE,
}

export type TReducerAction<
    TExportData extends { [key: string]: unknown } = { [key: string]: unknown }
> = {
    type: ActionTypes;
    payload: Partial<TState<TExportData>>;
};

export function setStateAction<
    TExportData extends { [key: string]: unknown } = { [key: string]: unknown }
>(state: Partial<TState<TExportData>>): TReducerAction<TExportData> {
    return {
        type: ActionTypes.SET_STATE,
        payload: {
            ...state,
        },
    };
}
